<template>
	<div>
		<!-- Edit -->
		<svg
			v-if="name === 'edit'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Add -->
		<svg
			v-else-if="name === 'add'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path d="m19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6z" />
			<path d="m0 0h24v24h-24z" fill="none" />
		</svg>

		<!-- Delete -->
		<svg
			v-else-if="name === 'delete'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Search -->
		<svg
			v-else-if="name === 'search'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Business -->
		<svg
			v-else-if="name === 'business'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path
				:class="color"
				d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
			/>
		</svg>

		<!-- People -->
		<svg
			v-else-if="name === 'people'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path
				:class="color"
				d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
			/>
		</svg>

		<!-- Person -->
		<svg
			v-else-if="name === 'person'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Notifications -->
		<svg
			v-else-if="name === 'notifications'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 22a2 2 0 0 0 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3-1.6-5.6-4.5-6.3V4a1.5 1.5 0 1 0-3 0v.7C7.6 5.4 6 7.9 6 11v5l-2 2v1h16v-1l-2-2z"
			/>
		</svg>

		<!-- Chevron-right -->
		<svg
			v-if="name === 'chevron-right'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M9.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"
			/>
		</svg>

		<!-- Chevron-down -->
		<svg
			v-if="name === 'chevron-down'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
		</svg>

		<svg
			v-if="name === 'chevron-left'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M14.7 15.3a1 1 0 0 1-1.4 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.4 1.4L11.42 12l3.3 3.3z"
			/>
		</svg>

		<!-- Dash -->
		<svg
			v-if="name === 'dash'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path d="M19 13H5v-2h14v2z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Circle -->
		<svg
			v-if="name === 'circle'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<circle cx="12" cy="12" r="5" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Claims -->
		<svg
			v-if="name === 'claims'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M18 14.74a4 4 0 0 0-8 .26H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-1 1.74zM10 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
			/>
			<path
				d="M7 9h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm7 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
			/>
		</svg>

		<!-- Clients -->
		<svg
			v-if="name === 'clients'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
			<path
				d="M21 20v-1a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v1c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2z"
			/>
		</svg>

		<!-- Dashboard -->
		<svg
			v-if="name === 'dashboard'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M9 22H5a1 1 0 0 1-1-1V11l8-8 8 8v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1zm3-9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
			/>
			<path
				d="M12.01 4.42l-8.3 8.3a1 1 0 1 1-1.42-1.41l9.02-9.02a1 1 0 0 1 1.41 0l8.99 9.02a1 1 0 0 1-1.42 1.41l-8.28-8.3z"
			/>
		</svg>

		<!-- Policies -->
		<svg
			v-if="name === 'policies'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M6 2h6v6c0 1.1.9 2 2 2h6v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm2 11a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2H8zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2H8z"
			/>
			<polygon points="14 2 20 8 14 8" />
		</svg>

		<!-- Products -->
		<svg
			v-if="name === 'products'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M5 5h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2zm3 7a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2H8zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2H8z"
			/>
			<path
				d="M15 4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6c0-1.1.9-2 2-2 0-1.1.9-2 2-2h2a2 2 0 0 1 2 2z"
			/>
		</svg>

		<!-- Quotes -->
		<svg
			v-if="name === 'quotes'"
			version="1.1"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 482.874 482.874"
			style="enable-background:new 0 0 482.874 482.874;"
			xml:space="preserve"
		>
			<g>
				<path
					d="M412.149,70.761c-94.3-94.3-247.1-94.3-341.4,0c-90.8,90.7-94.2,235.8-10.2,330.6l2.5,2c-9.1,19.7-24.8,44-49.7,56.2
					c-8.2,4-6.3,16.3,2.7,17.7c27.2,4.3,66.3-0.5,102.6-28l0.5,0.4c92.5,54.4,213.6,41.9,293-37.5
					C506.449,317.861,506.449,165.061,412.149,70.761z M305.849,329.861c-9.8,11.9-22.5,19.9-37.4,24c-6.5,1.8-9.4,5.2-9.1,11.9
					c0.3,6.6,0,13.2-0.1,19.9c0,5.9-3,9.1-8.8,9.2c-7.1,0.2-14.3,0.2-21.4,0c-6.2-0.1-9.2-3.7-9.3-9.8c-0.1-4.8-0.1-9.7-0.1-14.5
					c-0.1-10.7-0.4-11.1-10.7-12.7c-13.1-2.1-26-5.1-38-10.9c-9.4-4.6-10.4-6.9-7.7-16.8c2-7.4,4-14.7,6.3-22c2.7-8.5,4.9-9.5,12.7-5.5
					c13.3,6.9,27.4,10.8,42.2,12.6c9.5,1.2,18.9,0.2,27.7-3.6c16.5-7.2,19.1-26.3,5.1-37.8c-4.7-3.9-10.1-6.8-15.8-9.3
					c-14.4-6.3-29.5-11.2-43.2-19.4c-22.1-13.3-36.2-31.4-34.5-58.4c1.9-30.5,19.1-49.5,47-59.6c11.5-4.2,11.6-4,11.6-16.1
					c0-4.1-0.1-8.2,0.1-12.2c0.2-9.1,1.8-10.6,10.8-10.9c2.8-0.1,5.6,0,8.4,0c19.3,0,19.3,0,19.3,19.2c0.1,13.6,0,13.7,13.6,15.8
					c10.4,1.6,20.3,4.7,29.9,8.9c5.3,2.3,7.3,6,5.7,11.6c-2.4,8.3-4.7,16.7-7.3,24.9c-2.5,7.8-5,8.9-12.5,5.3
					c-15-7.3-30.8-10.3-47.4-9.4c-4.4,0.2-8.6,0.8-12.6,2.6c-14.4,6.3-16.7,22.1-4.5,31.9c6.2,4.9,13.2,8.5,20.6,11.6
					c12.7,5.3,25.5,10.3,37.6,17C322.549,248.761,332.849,296.961,305.849,329.861z"
				/>
			</g>
		</svg>

		<!-- Reports -->
		<svg
			v-if="name === 'reports'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5h3a1 1 0 0 0 .83-.45L10 8.8l5.17 7.75a1 1 0 0 0 1.66 0l1.7-2.55H21z"
			/>
			<path
				d="M21 12h-3a1 1 0 0 0-.83.45L16 14.2l-5.17-7.75a1 1 0 0 0-1.66 0L5.47 12H3V5c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v7z"
			/>
		</svg>

		<!-- Settings -->
		<svg
			v-if="name === 'settings'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M6.8 3.45c.87-.52 1.82-.92 2.83-1.17a2.5 2.5 0 0 0 4.74 0c1.01.25 1.96.65 2.82 1.17a2.5 2.5 0 0 0 3.36 3.36c.52.86.92 1.8 1.17 2.82a2.5 2.5 0 0 0 0 4.74c-.25 1.01-.65 1.96-1.17 2.82a2.5 2.5 0 0 0-3.36 3.36c-.86.52-1.8.92-2.82 1.17a2.5 2.5 0 0 0-4.74 0c-1.01-.25-1.96-.65-2.82-1.17a2.5 2.5 0 0 0-3.36-3.36 9.94 9.94 0 0 1-1.17-2.82 2.5 2.5 0 0 0 0-4.74c.25-1.01.65-1.96 1.17-2.82a2.5 2.5 0 0 0 3.36-3.36zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
			/>
			<circle cx="12" fill="white" cy="12" r="2" />
		</svg>

		<!-- Commissions -->
		<svg
			v-if="name === 'commissions'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Users -->
		<svg
			v-if="name === 'users'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path
				d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
			/>
		</svg>

		<!-- Referrals -->
		<svg
			v-if="name === 'internals'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				fill="none"
				d="M0 0h24v24H0z"
			/>
			<g fill-rule="evenodd" clip-rule="evenodd">
				<path
					d="M9 17l3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4"
				/>
				<path d="M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z" />
			</g>
		</svg>

		<!-- Leads -->
		<svg
			v-if="name === 'leads'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M12 2c-4.97 0-9 4.03-9 9 0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11c0-4.97-4.03-9-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
			/>
			<path fill="none" d="M0 0h24v24H0z" />
		</svg>

		<!-- Filter -->
		<svg
			v-if="name === 'filter'"
			class="ico"
			:class="color"
			version="1.1"
			id="Capax_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 971.986 971.986"
			style="enable-background:new 0 0 971.986 971.986;"
			xml:space="preserve"
		>
			<g>
				<path
					d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
					c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
					c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
				/>
			</g>
		</svg>

		<!-- Email -->
		<svg
			v-if="name === 'email'"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
		>
			<path
				class="primary"
				d="M22 8.62V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.62l9.55 4.77a1 1 0 0 0 .9 0L22 8.62z"
			/>
			<path
				class="secondary"
				d="M12 11.38l-10-5V6c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v.38l-10 5z"
			/>
		</svg>

		<!-- Password -->
		<svg
			v-if="name === 'password'"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
		>
			<path
				class="primary"
				d="M5 10h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm6 6.73V18a1 1 0 0 0 2 0v-1.27a2 2 0 1 0-2 0z"
			/>
			<path
				class="secondary"
				d="M12 19a1 1 0 0 0 1-1v-1.27A2 2 0 0 0 12 13v-3h3V7a3 3 0 0 0-6 0v3H7V7a5 5 0 1 1 10 0v3h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7v-3z"
			/>
		</svg>

		<!-- Account -->
		<svg
			v-if="name === 'account'"
			xmlns="http://www.w3.org/2000/svg"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 510 510"
			style="enable-background:new 0 0 510 510;"
			xml:space="preserve"
		>
			<g id="account-circle">
				<path
					d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M255,76.5
					c43.35,0,76.5,33.15,76.5,76.5s-33.15,76.5-76.5,76.5c-43.35,0-76.5-33.15-76.5-76.5S211.65,76.5,255,76.5z M255,438.6
					c-63.75,0-119.85-33.149-153-81.6c0-51,102-79.05,153-79.05S408,306,408,357C374.85,405.45,318.75,438.6,255,438.6z"
				/>
			</g>
		</svg>

		<!-- Expand -->
		<svg
			v-if="name === 'expand'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<defs>
				<path id="a" d="M0 0h24v24H0z" />
			</defs>
			<clipPath id="b">
				<use xlink:href="#a" overflow="visible" />
			</clipPath>
			<path
				clip-path="url(#b)"
				d="M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
			/>
			<path clip-path="url(#b)" fill="none" d="M0 0h24v24H0z" />
		</svg>

		<!-- zoom-in -->
		<svg
			v-if="name === 'zoom-in'"
			:class="color"
			viewBox="0 0 20 20"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="a" stroke="none" stroke-width="1" fill-rule="evenodd">
				<g id="icon-shape">
					<path
						d="M7,7 L5,7 L5,9 L7,9 L7,11 L9,11 L9,9 L11,9 L11,7 L9,7 L9,5 L7,5 L7,7 Z M12.9056439,14.3198574 C11.5509601,15.3729184 9.84871145,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,9.84871145 15.3729184,11.5509601 14.3198574,12.9056439 L19.6568542,18.2426407 L18.2426407,19.6568542 L12.9056439,14.3198574 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z"
						id="Combined-Shape"
					/>
				</g>
			</g>
		</svg>

		<!-- zoom-out -->
		<svg
			v-if="name === 'zoom-out'"
			:class="color"
			viewBox="0 0 20 20"
			:width="computedSize"
			:height="computedSize"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">
				<g id="icon-shape">
					<path
						d="M12.9056439,14.3198574 C11.5509601,15.3729184 9.84871145,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,9.84871145 15.3729184,11.5509601 14.3198574,12.9056439 L19.6568542,18.2426407 L18.2426407,19.6568542 L12.9056439,14.3198574 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M5,7 L11,7 L11,9 L5,9 L5,7 Z"
						id="Combined-Shape"
					/>
				</g>
			</g>
		</svg>

		<!-- Cross -->
		<svg
			v-if="name === 'cross'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			viewBox="0 0 24 24"
		>
			<path
				d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Organizations -->
		<svg
			v-if="name === 'organizations'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 470.11 470.109"
			style="enable-background:new 0 0 470.11 470.109;"
			xml:space="preserve"
		>
			<g>
				<path
					d="M101.51,0v470.109h102.684v-105h61.72v105h102.685V0H101.51z M216.318,315.512h-61.721v-61.721h61.721V315.512z
		 M216.318,216.319h-61.721v-61.721h61.721V216.319z M216.318,117.124h-61.721V55.403h61.721V117.124z M315.511,315.512H253.79
		v-61.721h61.722V315.512z M315.511,216.319H253.79v-61.721h61.722V216.319z M315.511,117.124H253.79V55.403h61.722V117.124z"
				/>
			</g>
		</svg>

		<!-- Case Management -->
		<svg
			v-if="name === 'caseManagement'"
			class="ico"
			:class="color"
			xmlns="http://www.w3.org/2000/svg"
			:width="computedSize"
			:height="computedSize"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 24 24"
			style="enable-background:new 0 0 470.11 470.109;"
			xml:space="preserve"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path
				d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
			/>
		</svg>

		<!-- alignment -->
		<svg
			v-if="name === 'vertical-align-bottom'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M13,11h-2V3H9v8H7l3,3L13,11z M17.4,15H2.6C2.048,15,2,15.447,2,16c0,0.553,0.048,1,0.6,1h14.8
				c0.552,0,0.6-0.447,0.6-1C18,15.447,17.952,15,17.4,15z"
			/>
		</svg>

		<!-- Align Left -->
		<svg
			v-if="name === 'align-left'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M6,10l3,3v-2h8V9H9V7L6,10z M4,2C3.447,2,3,2.047,3,2.6v14.8C3,17.951,3.447,18,4,18c0.552,0,1-0.049,1-0.6
	V2.6C5,2.047,4.552,2,4,2z"
			/>
		</svg>

		<!-- Align Right -->
		<svg
			v-if="name === 'align-right'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M11,7v2H3v2h8v2l3-3L11,7z M15,2.6v14.8c0,0.551,0.448,0.6,1,0.6c0.553,0,1-0.049,1-0.6V2.6
	C17,2.047,16.553,2,16,2C15.448,2,15,2.047,15,2.6z"
			/>
		</svg>

		<!-- Vertical align top -->
		<svg
			v-if="name === 'vertical-align-top'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M10,6L7,9h2v8h2V9h2L10,6z M18,4c0-0.553-0.048-1-0.6-1H2.6C2.048,3,2,3.447,2,4s0.048,1,0.6,1h14.8
	C17.952,5,18,4.553,18,4z"
			/>
		</svg>

		<!-- Vertical align center -->
		<svg
			v-if="name === 'vertical-align-center'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M10,12l-3,3h2v4h2v-4h2L10,12z M13,5h-2V1H9v4H7l3,3L13,5z M18,10c0-0.553-0.048-1-0.6-1H2.6
	C2.048,9,2,9.447,2,10c0,0.551,0.048,1,0.6,1h14.8C17.952,11,18,10.551,18,10z"
			/>
		</svg>

		<!-- Align Center -->
		<svg
			v-if="name === 'align-center'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<path
				d="M8,10L5,7v2H1v2h4v2L8,10z M15,13v-2h4V9h-4V7l-3,3L15,13z M10,18c0.553,0,1-0.049,1-0.6V2.6
	C11,2.047,10.553,2,10,2C9.448,2,9,2.047,9,2.6v14.8C9,17.951,9.448,18,10,18z"
			/>
		</svg>

		<!-- PDF -->
		<svg
			v-if="name === 'file-type-pdf'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				class="heroicon-ui"
				d="M6 2h9a1 1 0 0 1 .7.3l4 4a1 1 0 0 1 .3.7v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 0 1-2-2V4H6v16h12V9zm-2 7a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1zm-5-4a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1z"
			/>
		</svg>

		<!-- PDF 2 -->
		<svg
			v-if="name === 'file-type-pdf2'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<g
				id="Page-1"
				stroke="none"
				stroke-width="1"
				fill="none"
				fill-rule="evenodd"
			>
				<g
					id="Dribbble-Light-Preview"
					transform="translate(-340.000000, -1279.000000)"
					fill="#000000"
				>
					<g id="icons" transform="translate(56.000000, 160.000000)">
						<path
							d="M303.7144,1125.149 L298.2594,1119.364 C298.0704,1119.165 297.8034,1119.001 297.5294,1119.001 L285.9794,1119.001 C284.8744,1119.001 284.0004,1120.001 284.0004,1121.105 L284.0004,1128.105 C284.0004,1128.657 284.4374,1129.001 284.9894,1129.001 L284.9944,1129.001 C285.5474,1129.001 286.0004,1128.657 286.0004,1128.105 L286.0004,1122.105 C286.0004,1121.553 286.4274,1121.001 286.9794,1121.001 L296.0004,1121.001 L296.0004,1125.105 C296.0004,1126.21 296.8744,1127.001 297.9794,1127.001 L302.0004,1127.001 L302.0004,1128.105 C302.0004,1128.657 302.4374,1129.001 302.9894,1129.001 L302.9944,1129.001 C303.5474,1129.001 304.0004,1128.657 304.0004,1128.105 L304.0004,1125.838 C304.0004,1125.581 303.8914,1125.335 303.7144,1125.149 L303.7144,1125.149 Z M287.9794,1134.105 C287.9794,1133.553 287.5314,1133.105 286.9794,1133.105 L285.9794,1133.105 L285.9794,1135.105 L286.9794,1135.105 C287.5314,1135.105 287.9794,1134.657 287.9794,1134.105 L287.9794,1134.105 Z M289.9754,1133.839 C290.0654,1135.569 288.6894,1137.001 286.9794,1137.001 L286.0004,1137.001 L286.0004,1138.105 C286.0004,1138.657 285.5474,1139.001 284.9944,1139.001 L284.9894,1139.001 C284.4374,1139.001 284.0004,1138.657 284.0004,1138.105 L284.0004,1132.105 C284.0004,1131.553 284.4274,1131.001 284.9794,1131.001 L286.8094,1131.001 C288.4344,1131.001 289.8904,1132.217 289.9754,1133.839 L289.9754,1133.839 Z M295.0004,1134.105 C295.0004,1133.553 294.5314,1133.001 293.9794,1133.001 L293.0004,1133.001 L293.0004,1137.001 L293.9794,1137.001 C294.5314,1137.001 295.0004,1136.657 295.0004,1136.105 L295.0004,1134.105 Z M297.0004,1134.001 L297.0004,1136.001 C297.0004,1137.651 295.6504,1139.001 294.0004,1139.001 L291.8954,1139.001 C291.4004,1139.001 291.0004,1138.6 291.0004,1138.105 L291.0004,1131.98 C291.0004,1131.439 291.4384,1131.001 291.9794,1131.001 L294.0004,1131.001 C295.6504,1131.001 297.0004,1132.351 297.0004,1134.001 L297.0004,1134.001 Z M304.0004,1132.027 L304.0004,1132.053 C304.0004,1132.605 303.5314,1133.001 302.9794,1133.001 L300.0004,1133.001 L300.0004,1135.001 L302.9794,1135.001 C303.5314,1135.001 304.0004,1135.474 304.0004,1136.027 L304.0004,1136.053 C304.0004,1136.605 303.5314,1137.001 302.9794,1137.001 L300.0004,1137.001 L300.0004,1138.105 C300.0004,1138.657 299.5474,1139.001 298.9944,1139.001 L298.9894,1139.001 C298.4374,1139.001 298.0004,1138.657 298.0004,1138.105 L298.0004,1132.105 C298.0004,1131.553 298.4274,1131.001 298.9794,1131.001 L302.9794,1131.001 C303.5314,1131.001 304.0004,1131.474 304.0004,1132.027 L304.0004,1132.027 Z"
							id="file_pdf-[#1754]"
						/>
					</g>
				</g>
			</g>
		</svg>

		<!-- File type email -->
		<svg
			v-if="name === 'file-type-email'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				class="heroicon-ui"
				d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm16 3.38V6H4v1.38l8 4 8-4zm0 2.24l-7.55 3.77a1 1 0 0 1-.9 0L4 9.62V18h16V9.62z"
			/>
		</svg>

		<!-- Down -->
		<svg
			v-if="name === 'down'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="caret-down"
			class="svg-inline--fa fa-caret-down fa-w-10"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 320 512"
		>
			<path
				fill="currentColor"
				d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
			/>
		</svg>

		<!-- Up -->
		<svg
			v-if="name === 'up'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="caret-up"
			class="svg-inline--fa fa-caret-up fa-w-10"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 320 512"
		>
			<path
				fill="currentColor"
				d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
			/>
		</svg>

		<!-- Binders -->
		<svg
			v-if="name === 'binders'"
			class="ico"
			:class="color"
			:width="computedSize"
			:height="computedSize"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enable-background="new 0 0 20 20"
			xml:space="preserve"
		>
			<defs>
				<path id="a" d="M0 0h24v24H0z" />
			</defs>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
			/>
		</svg>

		<!-- File download -->
		<svg
			v-if="name === 'file-download'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-download"
			class="svg-inline--fa fa-file-download fa-w-12"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 384 512"
		>
			<path
				fill="currentColor"
				d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
			/>
		</svg>

		<!-- Folder -->
		<svg
			v-if="name === 'folder'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="folder"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Create folder -->
		<svg
			v-if="name === 'create-folder'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-icon="create-folder"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path
				d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
			/>
		</svg>

		<!-- Refresh -->
		<svg
			v-if="name === 'refresh'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="folder"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Upload -->
		<svg
			v-if="name === 'upload'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="upload"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
			/>
		</svg>

		<!-- Image -->
		<svg
			v-if="name === 'file-type-image'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-image"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Video -->
		<svg
			v-if="name === 'file-type-video'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-video"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Music -->
		<svg
			v-if="name === 'file-type-music'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-music"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path
				d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
			/>
		</svg>

		<!-- Text -->
		<svg
			v-if="name === 'file-type-text'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-text"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<g>
				<rect fill="none" height="24" width="24" />
			</g>
			<g>
				<g>
					<g>
						<path d="M2.5,4v3h5v12h3V7h5V4H2.5z M21.5,9h-9v3h3v7h3v-7h3V9z" />
					</g>
				</g>
			</g>
		</svg>

		<!-- Chart -->
		<svg
			v-if="name === 'file-type-chart'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-chart"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
			/>
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>

		<!-- Code -->
		<svg
			v-if="name === 'file-type-code'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="file-type-code"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0V0z" fill="none" />
			<path
				d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
			/>
		</svg>

		<!-- Warning -->
		<svg
			v-if="name === 'warning'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="warning"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
		</svg>

		<!-- Payment -->
		<svg
			v-if="name === 'payment'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="payment"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path d="M0 0h24v24H0z" fill="none" />
			<path
				d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
			/>
		</svg>

		<!-- Privacy -->
		<svg
			v-if="name === 'privacy'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="privacy"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<path
				d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
			/>
		</svg>

		<!-- Kebab menu -->
		<svg
			v-if="name === 'kebab'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="kebab"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
		>
			<ellipse
				ry="2"
				rx="2"
				id="svg_1"
				cy="5"
				cx="11.999999"
				stroke-width="1.5"
			/>
			<ellipse
				ry="2"
				rx="2"
				id="svg_2"
				cy="12.000001"
				cx="12"
				stroke-width="1.5"
			/>
			<ellipse
				ry="2"
				rx="2"
				id="svg_4"
				cy="19"
				cx="12.000001"
				stroke-width="1.5"
			/>
		</svg>

		<!-- Back -->
		<svg
			v-if="name === 'back'"
			:width="computedSize"
			:height="computedSize"
			class="svg-inline--fa fa-arrow-left fa-w-14"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="arrow-left"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
		>
			<path
				fill="currentColor"
				d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
			/>
		</svg>

		<!-- Paste -->
		<svg
			v-if="name === 'paste'"
			:width="computedSize"
			:height="computedSize"
			class="ico"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="paste"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 600 550"
		>
			<g>
				<g>
					<path
						d="M368.64,0H20.48C9.175,0,0,9.175,0,20.48v348.16c0,11.305,9.175,20.48,20.48,20.48h348.16
			c11.305,0,20.48-9.175,20.48-20.48V20.48C389.12,9.175,379.945,0,368.64,0z M348.16,348.16H40.96V40.96h307.2V348.16z"
					/>
				</g>
			</g>
			<g>
				<g>
					<path
						d="M471.04,419.84v51.2h-51.2V512h71.68c11.305,0,20.48-9.175,20.48-20.48v-71.68H471.04z"
					/>
				</g>
			</g>
			<g>
				<g>
					<rect x="262.349" y="471.04" width="110.182" height="40.96" />
				</g>
			</g>
			<g>
				<g>
					<path
						d="M163.84,471.04v-51.2h-40.96v71.68c0,11.305,9.175,20.48,20.48,20.48h71.68v-40.96H163.84z"
					/>
				</g>
			</g>
			<g>
				<g>
					<path
						d="M491.52,122.88h-71.68v40.96h51.2v51.2H512v-71.68C512,132.055,502.825,122.88,491.52,122.88z"
					/>
				</g>
			</g>
			<g>
				<g>
					<rect x="471.04" y="262.349" width="40.96" height="110.182" />
				</g>
			</g>
		</svg>

		<svg
			v-if="name === 'box'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			class="ml1 mr1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			version="1.1"
			viewBox="0 0 24 24"
		>
			<path
				d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z"
			/>
		</svg>

		<svg
			v-if="name === 'education'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			class="ml1 mr1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			version="1.1"
			viewBox="0 0 24 24"
		>
			<path
				d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
			/>
		</svg>

		<svg
			v-if="name === 'resources'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			class="ml1 mr1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			version="1.1"
			viewBox="0 0 24 24"
		>
			<g><rect fill="none" height="24" width="24" /></g>
			<g>
				<g />
				<g>
					<path
						d="M21,5c-1.11-0.35-2.33-0.5-3.5-0.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65 c0,0.25,0.25,0.5,0.5,0.5c0.1,0,0.15-0.05,0.25-0.05C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5 c1.65,0,3.35,0.3,4.75,1.05c0.1,0.05,0.15,0.05,0.25,0.05c0.25,0,0.5-0.25,0.5-0.5V6C22.4,5.55,21.75,5.25,21,5z M21,18.5 c-1.1-0.35-2.3-0.5-3.5-0.5c-1.7,0-4.15,0.65-5.5,1.5V8c1.35-0.85,3.8-1.5,5.5-1.5c1.2,0,2.4,0.15,3.5,0.5V18.5z"
					/>
					<g>
						<path
							d="M17.5,10.5c0.88,0,1.73,0.09,2.5,0.26V9.24C19.21,9.09,18.36,9,17.5,9c-1.7,0-3.24,0.29-4.5,0.83v1.66 C14.13,10.85,15.7,10.5,17.5,10.5z"
						/>
						<path
							d="M13,12.49v1.66c1.13-0.64,2.7-0.99,4.5-0.99c0.88,0,1.73,0.09,2.5,0.26V11.9c-0.79-0.15-1.64-0.24-2.5-0.24 C15.8,11.66,14.26,11.96,13,12.49z"
						/>
						<path
							d="M17.5,14.33c-1.7,0-3.24,0.29-4.5,0.83v1.66c1.13-0.64,2.7-0.99,4.5-0.99c0.88,0,1.73,0.09,2.5,0.26v-1.52 C19.21,14.41,18.36,14.33,17.5,14.33z"
						/>
					</g>
				</g>
			</g>
		</svg>

		<!-- Right -->
		<svg
			v-if="name === 'right'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="caret-right"
			class="svg-inline--fa fa-caret-right fa-w-6"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 192 512"
		>
			<path
				fill="currentColor"
				d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
			></path>
		</svg>

		<!-- Achievements -->
		<svg
			v-if="name === 'achievements'"
			:width="computedSize"
			:height="computedSize"
			:class="color"
			class="ml1 mr1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			version="1.1"
			viewBox="0 0 24 24"
		>
			<rect fill="none" height="24" width="24" />
			<path
				d="M19,5h-2V3H7v2H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94c0.63,1.5,1.98,2.63,3.61,2.96V19H7v2h10v-2h-4v-3.1 c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M19,8 c0,1.3-0.84,2.4-2,2.82V7h2V8z"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: "crm-icon",

	props: {
		name: {
			type: String,
			required: true,
			default: "edit"
		},
		color: {
			type: String,
			required: false,
			default: "c1"
		},
		size: {
			type: String,
			required: false,
			default: "normal"
		}
	},

	computed: {
		computedSize() {
			if (this.size === "xsmall") return "10"
			else if (this.size === "small") return "14"
			else if (this.size === "normal") return "18"
			else if (this.size === "large") return "24"
			else return "30"
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.ico {
	margin: 0 var(--spacing1);
}

.c1 {
	fill: var(--color1);
}

.c2 {
	fill: var(--color2);
}

.c3 {
	fill: var(--color3);
}

.c4 {
	fill: var(--color4);
}

.c5 {
	fill: var(--color5);
}

.c6 {
	fill: var(--color6);
}

.c7 {
	fill: var(--color7);
}

.cError {
	fill: var(--colorError);
}

.cWarning {
	fill: var(--colorWarning);
}

.cSuccess {
	fill: var(--colorSuccess);
}
</style>
